/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { IUserDetails } from "interfaces";
import GeneralUtils from "GeneralUtils";
import userDataUtil from "services/user-data-util";
import { httpIAM } from "../../services/http.IAM";
import login from "../../assets/images/login.jpg";

import { getUserNameFromJwt, isJwtExpired, getSafeReturnUrl } from "./utils";

const SsoLoginOtp: React.FC = () => {
  const history = useHistory();
  const location = useLocation();

  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string>("");

useEffect(() => {
  const params = new URLSearchParams(location.search);
  const otp = params.get("otp");
  const returnUrl = getSafeReturnUrl(params.get("redirect") || "/");

const existingToken = GeneralUtils.getCookieValue("AUTH_TOKEN");

if (existingToken) {
  // Check JWT expiration
  if (isJwtExpired(existingToken)) {
    // Token exists but is expired then force re-login
    GeneralUtils.appendCookie("AUTH_TOKEN", "");
    GeneralUtils.appendCookie("USER_DETAILS", "");

    history.replace("/login");
    return;
  }

  // Token exists AND is valid then proceed without OTP
  const userName = getUserNameFromJwt(existingToken);

  if (!userName) {
    history.replace("/login");
    return;
  }

  httpIAM
    .getUserDetails(userName)
    .then((user: IUserDetails) => {
      if (user) {
        GeneralUtils.appendCookie("USER_DETAILS", JSON.stringify(user));

        const previousDatabase =
          GeneralUtils.getCookieValue("DATABASE");

        if (
          user.databases?.length > 0 &&
          (!previousDatabase ||
            !user.databases.find((x) => x.id === previousDatabase))
        ) {
          GeneralUtils.appendCookie("DATABASE", user.databases[0].id);
        }
      }

      userDataUtil.initializeUserStats();
      GeneralUtils.clearGlobalVars();

      history.replace(returnUrl);
    })
    .catch(() => {
      history.replace("/login");
    });

  return;
}


  /**
   * No token and no OTP then redirect to login
   */
  if (!otp) {
    history.replace("/login?error=sso_failed");
    return;
  }

  /**
   *  Exchange OTP ONLY ONCE
   */
  setLoading(true);
  setError("");

  httpIAM
    .exchangeOtp(otp)
    .then((authToken: string) => {
      if (!authToken) {
        history.replace("/login?error=sso_failed");
        return;
      }

      GeneralUtils.appendCookie("INIT_USER_STATS", "");
      GeneralUtils.appendCookie("AUTH_TOKEN", authToken);

      const userName = getUserNameFromJwt(authToken);
      if (!userName) {
        history.replace("/login?error=sso_failed");
        return;
      }

      return httpIAM.getUserDetails(userName).then((user: IUserDetails) => {
        if (user) {
          GeneralUtils.appendCookie("USER_DETAILS", JSON.stringify(user));

          const previousDatabase = GeneralUtils.getCookieValue("DATABASE");
          if (
            user.databases?.length > 0 &&
            (!previousDatabase ||
              !user.databases.find((x) => x.id === previousDatabase))
          ) {
            GeneralUtils.appendCookie("DATABASE", user.databases[0].id);
          }
        }

        userDataUtil.initializeUserStats();
        GeneralUtils.clearGlobalVars();

        history.replace(returnUrl);
      });
    })
    .catch(() => {
      // IMPORTANT FIX — redirect instead of hanging
      history.replace("/login?error=sso_failed");
    })
    .finally(() => {
      setLoading(false);
    });
}, [location.search, history]);


 
  return (
    <div
      className="w-100 height-100vh"
      style={{
        backgroundImage: `url(${login})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      }}
    >
      <div className="position-absolute w-100">
        <div className="m-auto mt50 w500 background-color-light p30 rounded shadow-lg text-center">
          <h3 className="mb20">Signing you in…</h3>

          {error !== "" ? (
            <div className="text-danger">{error}</div>
          ) : loading ? (
            <div>Please wait.</div>
          ) : (
            <div>Loading…</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SsoLoginOtp;
